<template>
  <div id="languageSelector" class="language-selector" @click="toggleLanguageSelection">
    <BaseImage
      :image-class="{rotate: isOpen}"
      id="languageIcon"
      src="/static/images/header-menu/lang.svg"
      alt="Language"
    />

    <i id="chevronIcon" :class="['fas fa-chevron-down', {rotate: isOpen}]"></i>

    <div class="vert_sep"></div>

    <ul
      v-if="isOpen"
      v-click-outside-directive="{handler: closeLanguageSelection, parentId: 'languageSelector'}"
      class="language-dropdown active"
    >
      <li v-for="(lValue, lKey) in localeStore.languages" :key="lKey">
        <a href="#" @click.prevent="handleLanguageChange(lKey)">{{ lValue }}</a>
      </li>
    </ul>
  </div>
</template>

<script setup>
import BaseImage from '@/components/image/BaseImage.vue';
import useLocaleStore from '@/store/modules/locale.js';
import useDropdownHook from '@/hooks/useDropdown.js';
import useUILockHook from '@/hooks/useUILock.js';
import vClickOutsideDirective from '@/directives/vClickOutside.js';

const localeStore = useLocaleStore();

const [isOpen, toggleLanguageSelection, closeLanguageSelection] = useDropdownHook();
const [_uiLockState, setUILockState] = useUILockHook();

const handleLanguageChange = async (lKey) => {
  closeLanguageSelection();

  if (localeStore.currentLanguage === lKey) { return; }

  setUILockState(true);

  await localeStore.changeLanguage(lKey);

  setUILockState(false);
};
</script>
